module.exports = __webpack_public_path__ + "images/1c1e65d2d274054ab7d23dc61128b5d24.svg";